import { Switch as Mui4Switch } from '@material-ui/core'
import { default as Mui5Switch, SwitchProps as Mui5SwitchPropsType } from '@mui/material/Switch'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsSwitchVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type SwitchProps = Mui5SwitchPropsType
/** @deprecated Use SwitchProps */
export type OsSwitchProps = SwitchProps

// * MUI Switch API Spec  https://mui.com/material-ui/api/switch/
export const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
  const version = useComponentVersion('switch')
  switch (version) {
    case OsSwitchVersion.V2:
      return <Mui5Switch disableRipple ref={ref} {...props} />

    default:
      const { color, ...rest } = props
      const color4 =
        color === 'warning' || color === 'info' || color === 'success' || color === 'error' ? 'default' : color
      return <Mui4Switch ref={ref} {...rest} color={color4} />
  }
})
